import { ReactElement, useEffect } from 'react'
import { CorneredSection } from '@ui2/structure'
import { useControlStore } from '@editorStores'
import { useScopedSelectionReset } from '@editorHooks'
import IFCWallAutoConnectSection from '../IFCWallAutoConnectSection'

/**
 * Drawer panel of the "Wände automatisch zuschneiden" toolbar tool — the non-guided counterpart of
 * the wall edit step's "Automatisch" tool (`IFCWallAutoConnectSection`). While shown, planar
 * selection is restricted to no types so canvas clicks don't open edit forms next to the connection
 * proposal, mirroring the guided step's behavior. Also resets the scene selection on enter/leave
 * (like the guided step) so a wall selected before entering the tool doesn't keep its edit handles
 * rendered on top of the connection proposal.
 */
const IFCWallAutoConnectPanel = (): ReactElement => {
  const setPlanarSelectableTypes = useControlStore(state => state.setPlanarSelectableTypes)

  useEffect(() => {
    setPlanarSelectableTypes([])

    return () => setPlanarSelectableTypes(null)
  }, [setPlanarSelectableTypes])

  useScopedSelectionReset()

  return (
    <CorneredSection>
      <IFCWallAutoConnectSection />
    </CorneredSection>
  )
}

export default IFCWallAutoConnectPanel
